<template>
  <div class="row my-2">
    <div class="col-12 col-md-4 col-lg-3 col-xl-2 d-flex align-items-center">
      <p class="mb-0">
        <strong>Placement</strong>
        <br>{{ placement.number }}
      </p>
    </div>
    <div class="col-6 col-md-4 col-lg-3 col-xl-2 d-flex align-items-center">
      <p class="mb-0">
        <strong>Start Date</strong>
        <br>{{ placement.start_date | date }}
      </p>
    </div>
    <div class="col-6 col-md-4 col-lg-3 col-xl-2 d-flex align-items-center">
      <p class="mb-0">
        <strong>End Date</strong>
        <br>{{ placement.end_date | date }}
      </p>
    </div>
  </div><!-- /.row -->
</template>

<script>
export default {
  props: {
    placement: {
      required: true,
      type: Object
    }
  }
}
</script>
